export default __webpack_public_path__ + "static/media/baby1.6d84c089.png";